<template lang="pug">
  router-link.sdg-card.relative.row(:to='sdgLink')
    img.sdg-img.absolute(:src='require(`@/assets/ods/${locale}/${translationId}.png`)' :alt='$t(`sdg.${translationId}`)')
    .shadow.absolute
    .container.column.bottom
      h4.uppercase.text-normal.bold.white.m-bottom-05 {{ $t(`sdg.${translationId}`) }}
      router-link.text-normal.white.underline(:to='sdgLink') {{ $t("sdg.seeCollection") }}
</template>

<script>
import { mapState } from 'vuex'
import { routes } from '../router'

export default {
  props: {
    translationId: { type: String },
    image: { type: String },
    sdgId: { type: Number }
  },
  computed: {
    ...mapState({
      locale: state => state.behavior.locale
    }),
    sdgLink() {
      return {
        name: routes.search,
        query: {
          ...this.$route.query,
          ODSIds: this.$route.query && this.$route.query.ODSIds
            ? [...new Set(...this.$route.query.ODSIds, this.sdgId)]
            : [this.sdgId]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.sdg-card{
  height: 244px;
  border-radius: 8px;
  overflow: hidden;
  .shadow{
    height: 100%;
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0,0,0,0) 70%);
  }
  .container{
    padding: 16px;
    z-index: 1;
  }
  .sdg-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
